<template>
  <div>
    <v-overlay v-if="loading">
      <Loader />
    </v-overlay>

    <v-footer
      fixed
      bottom
      color="grey lighten-4"
      class="outlined py-6 hidden-md-and-up"
      style="border-radius: 12px 12px 0 0"
    >
      <!-- Return Check   -->
      <v-row
        justify="center"
        no-gutters
        v-if="booking.status == 'pending-return' && lenderView == true"
      >
        <v-row class="grid">
          <v-col class="grid">
            <v-switch
              class="black--text"
              color="secondary"
              v-model="happySwitch"
              :label="
                happySwitch == true
                  ? 'I am happy with my return'
                  : 'I am happy with my return'
              "
            >
            </v-switch>

            <v-row class="grid">
              <v-hover v-slot="{ hover }">
                <v-btn
                  :disabled="!happySwitch"
                  class="appbutton mx-1 mt-3 my-4 white--text font-weight-medium"
                  :elevation="hover ? 16 : 4"
                  :class="{ 'on-hover': hover }"
                  color="accent"
                  rounded
                  @click="approveReturn(booking)"
                >
                  <v-img
                    width="20px"
                    height="20px"
                    class="mr-3"
                    :src="require('@/assets/fontawesome/check-duotone.svg')"
                  />
                  Confirm Return
                </v-btn>
              </v-hover>
            </v-row></v-col
          >
        </v-row>
      </v-row>

      <!-- Item Quality Check   -->
      <v-row
        justify="center"
        no-gutters
        v-else-if="booking.status == 'awaiting-images' && lenderView == true"
      >
        <v-row class="grid">
          <v-col class="grid">
            <p class="text-body-2">Add Item Quality Check Images</p>
            <item-quality-dialog :booking="booking" class="my-n5">
            </item-quality-dialog
          ></v-col>
        </v-row>
      </v-row>

      <!-- Return Dialog for Lender   -->

      <v-col
        cols="12"
        md="12"
        class="mt-3 mb-n1"
        v-if="
          (booking.status == 'returned' && lenderView == true) ||
          (booking.status == 'returnedB' && lenderView == true)
        "
      >
        <v-row class="grid">
          <rating-dialog
            class="center"
            style="align-items: center"
            :booking="booking"
            :showBtn="true"
            :open="false"
          >
          </rating-dialog>
        </v-row>
      </v-col>

      <!-- Return Dialog for Borrower   -->

      <v-col
        cols="12"
        md="12"
        class="mt-3 mb-n1"
        v-if="
          (booking.status == 'returned' && borrowerView == true) ||
          (booking.status == 'returnedB' && borrowerView == true)
        "
      >
        <v-row class="grid">
          <rating-item-dialog
            class="center"
            style="align-items: center"
            :booking="booking"
            :showBtn="true"
            :open="false"
          >
          </rating-item-dialog>
        </v-row>
      </v-col>

      <!-- Make Payment   -->
      <v-row
        justify="center"
        no-gutters
        v-else-if="booking.status == 'awaiting-payment' && borrowerView == true"
      >
        <v-row class="grid">
          <div v-if="booking.status === 'awaiting-payment'">
            <paystack-button
              v-if="verified === true"
              @paySuccess="paySuccess()"
              :booking="booking"
            ></paystack-button>

            <v-btn
              v-if="verified === false"
              @click="toverify()"
              elevation="6"
              large
              block
              color="accent"
              class="ml-n3 appbutton ma-1 text-body-1 rounded-lg white--text font-weight-medium"
              z-index="12"
            >
              <base-img
                :src="require('@/assets/logos/icon1.svg')"
                contain
                max-height="35"
                max-width="35"
                class="mr-2"
              />
              Verify and Pay
            </v-btn>
          </div>
        </v-row>
      </v-row>

      <!-- Accept or decline  -->
      <v-row
        justify="center"
        no-gutters
        v-else-if="booking.status == 'pending' && borrowerView == false"
      >
        <accept-decline :booking="booking"></accept-decline>
        <!-- <v-col cols="12">
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              v-if="verified"
              class="appbutton mx-1 mt-3 white--text font-weight-medium"
              color="accent"
              rounded
              @click="acceptBooking(booking)"
            >
              <v-img
                width="20px"
                height="20px"
                class="mr-3"
                :src="require('@/assets/fontawesome/check-duotone.svg')"
              />
              Accept
              <span class="d-none d-sm-flex ml-1">booking</span>
            </v-btn>
            <v-btn
              v-else-if="!verified"
              class="appbutton mx-1 mt-3 white--text font-weight-medium"
              color="accent"
              rounded
              @click="verifyAcceptDialog = true"
            >
              <v-img
                width="20px"
                height="20px"
                class="mr-3"
                :src="require('@/assets/fontawesome/check-duotone.svg')" />
              Verify & Accept
              <span class="d-none d-sm-flex ml-1"></span
            ></v-btn>
            <v-spacer></v-spacer>
            <decline-booking-dialog :booking="booking"></decline-booking-dialog>
            <v-spacer></v-spacer>
          </v-row>
        </v-col> -->
      </v-row>
    </v-footer>

    <v-dialog
      style="border-radius: 12px !important; overflow: hidden"
      v-model="returnedDialog"
      width="550"
      persistent
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <!-- <v-icon small color="black" @click="acceptedDialog = false"
            >mdi-close</v-icon
          > -->
          <p class="my-3 ml-auto mr-auto">Item Returned! 🥳</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p class="pa-6">
              <span class="text-subtitle-1 font-weight-bold"
                >You have successfully completed this booking!</span
              >
              <br /><br />
              We would appreciate you taking the time to provide a rating and
              review on your lending experience. It goes a long way to improving
              the comunity trust on our platform. Thank you!
            </p>
          </v-col>
        </v-row>
        <div class="grid">
          <v-btn
            elevation="8"
            width="7rem"
            color="secondary"
            type="submit"
            value="Save Changes"
            class="ebtn"
            @click="
              refresh();
              returnedDialog = false;
            "
            >Continue</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="verifyAcceptDialog"
      scrollable
      max-width="450px"
      style="border-radius: 12px"
    >
      <stitch-verify-dialog :booking="booking" />
    </v-dialog>

    <v-dialog
      persistent
      style="border-radius: 12px !important; overflow: hidden"
      v-model="acceptedDialog"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <v-icon small color="black" @click="reload()">mdi-close</v-icon>
          <p class="my-3 ml-auto mr-auto">Booking Accepted! 🥳</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p class="pa-6">
              <span class="text-subtitle-2 font-weight-bold"
                >You have successfully accepted this booking!</span
              >
              <br /><br />
              Once we have verified received the payment from the borrower, we
              will send you a confirmation email. <br /><br />
              Until then this booking will have a status of 'Waiting for
              payment'
            </p>
          </v-col>
        </v-row>
        <div class="grid mt-n3">
          <v-btn class="appbutton mt-n3" @click="reload()">Continue</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import { getFunctions, httpsCallable } from "firebase/functions";

export default {
  name: "StrappBookingFooter",

  components: {
    PaystackButton: () => import("@/components/payments/paystackButton.vue"),
    DeclineBookingDialog: () => import("@/components/declineBookingDialog.vue"),
    LinkPay: () => import("@/components/LinkPay.vue"),
    Loader: () => import("@/components/Loader.vue"),
    ItemQualityDialog: () => import("@/components/ItemQualityDialog.vue"),
    StitchVerifyDialog: () =>
      import("@/components/booking/stitchVerifyDialog.vue"),
    RatingDialog: () => import("@/components/RatingDialog.vue"),
    RatingItemDialog: () => import("@/components/RatingItemDialog.vue"),
    acceptDecline: () => import("@/components/booking/acceptDecline.vue"),
  },

  props: {
    booking: {
      type: Object,
      required: true,
    },
    borrowerView: {
      type: Boolean,
      required: true,
    },
    lenderView: {
      type: Boolean,
      required: true,
    },
    // verified: {
    //   type: Boolean,
    //   required: true,
    // },
  },

  data() {
    return {
      verifyAcceptDialog: false,
      returnedDialog: false,
      happySwitch: false,
      acceptedDialog: false,
    };
  },

  mounted() {
    console.log("mounted", this.verified, this.borrowerView, this.lenderView);
  },

  computed: {
    // isBorrower() {
    //   return this.$store.getters['auth/isBorrower'];
    // },
    // isLender() {
    //   return this.$store.getters['auth/isLender'];
    // },
    verified() {
      if (
        this.$store.getters.user.stitch_verification_received ||
        this.$store.getters.user.manual_verification_received ||
        this.$store.getters.user.verified
      ) {
        return true;
      } else {
        return false;
      }
    },
    loading() {
      return this.$store.getters.loading;
    },
  },

  methods: {
    toverify() {
      this.$router.push({
        name: `Verify 📊`,
        params: { booking: this.booking },
      });
    },
    paySuccess() {
      this.$emit("paySuccess");
    },
    async approveReturn(booking) {
      try {
        await this.$store.dispatch("updateBookingData", {
          id: this.$route.params.id,
          status: "returned",
          updatedAt: new Date(),
        });

        // const db = getFirestore();
        // const bookingRef = doc(db, 'bookings', this.$route.params.id);

        // await updateDoc(bookingRef, {
        //   status: 'returned',
        //   returnedAt: new Date(),
        // });

        this.returnedDialog = true;
      } catch (error) {
        const errorMessage = error.message;
        alert(errorMessage);
      }
    },
    async acceptBooking(booking) {
      // console.log(booking);
      this.$store.commit("setLoading", true);
      console.log(booking);
      try {
        await this.$store.dispatch("updateBookingData", {
          id: booking.id,
          status: "awaiting-payment",
          updatedAt: new Date(),
        });

        // bookingRef.update({
        //   status: 'awaiting-payment',
        //   updatedAt: new Date(),
        // });
      } catch (error) {
        const errorMessage = error.message;
        alert(errorMessage);
      }

      this.acceptedDialog = true;
      this.$store.commit("setLoading", false);

      try {
        var addMessage = firebase
          .functions()
          .httpsCallable("bookingRequestAccepted");
        addMessage({
          email: booking.borrowerEmail,
          id: booking.id,
          borrowerName: booking.borrowerName,
          itemName: booking.itemName,
        });
      } catch (error) {
        const errorMessage = error.message;
        alert(errorMessage);
      }
    },

    refresh() {
      this.$router.go();
    },
  },
};
</script>

<style lang="scss" scoped>
.outlined {
  border: 1px solid black;
  border-radius: 12px;
  padding: 0.5rem;
}
</style>
